import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const SETTINGS_PANE_DESCRIPTION_CLASS_NAME = 'SettingsPaneDescription';
export const SETTINGS_PANE_DESCRIPTION_CLASS_SLOTS = ['root'] as const;

export type SettingsPaneDescriptionClassSlot =
	(typeof SETTINGS_PANE_DESCRIPTION_CLASS_SLOTS)[number];

export interface SettingsPaneDescriptionClasses {
	root: string;
}

export type SettingsPaneDescriptionClassKey =
	keyof SettingsPaneDescriptionClasses;

export const getSettingsPaneDescriptionUtilityClass = (slot: string) =>
	generateUtilityClass(SETTINGS_PANE_DESCRIPTION_CLASS_NAME, slot);

export const settingsPaneDescriptionClasses = generateUtilityClasses<
	keyof SettingsPaneDescriptionClasses
>(SETTINGS_PANE_DESCRIPTION_CLASS_NAME, ['root']);
export default settingsPaneDescriptionClasses;
